import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL = `${BaseUrl}favorite`;

export const addFavorite = (product) => {
    const token = localStorage.getItem('token');

    return axios.post(API_URL, product, {
        headers: {
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}


export const deleteFavorite = (id) => {
    const token = localStorage.getItem('token');

    return axios.delete(`${API_URL}/${id}`, {
        headers: {
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}
